import get from 'lodash/get'
import type { Connection, Edge, Node } from './types'

export const getConnectionNodes = (connection: Connection): Array<Node> => {
  return get(connection, 'edges', []).map((edge: Edge) => {
    return get(edge, 'node')
  })
}

export const getConnectionTotal = (connection: Connection): number => {
  return get(connection, 'total', 0)
}
